//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import ActiveCheckBox from '../../ActiveCheckbox';
import {useProductVariantContext} from '../../../context/productVariant';
import {useProductVariantRequestContext} from '../../../context/productVariantRequest';
import {useProductContext} from '../../../context';

const useStyles = makeStyles(theme => ({
  wholesalePrice: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '140px',
  },
}));

export default function VariantWholesalePriceCell() {
  const classes = useStyles();
  const variant = useProductVariantContext();
  const variantRequest = useProductVariantRequestContext();

  const [enabledBulkPrice] = useProductContext(
    product => product.bulkPriceSetting && product.bulkPriceSetting.enabled,
    false
  );

  if (!variant || !variantRequest) return null;

  return (
    <TableCell component="th" scope="row" align="right">
      <div className={classes.wholesalePrice}>
        <ActiveCheckBox
          disabled={!enabledBulkPrice}
          checked={variant.enabledBulkPrice}
          onChange={checked => {
            variantRequest.setEnabledBulkPrice(variant.id, checked);
          }}
        />
      </div>
    </TableCell>
  );
}
